// extracted by mini-css-extract-plugin
module.exports = {"partnerLogoWrapper":"_2BqzB","partnerLogo":"_1R9I8","partnerDescription":"bGXus","partnerTitle":"lWy61","partnerId":"_1uiR0"};